// extracted by mini-css-extract-plugin
export default {"navigation":"Navigation_navigation__RQw6s","link":"Navigation_link__Jlf0e","active":"Navigation_active__8X7xS"};